export const MANGO_PARAMETERS = {
  CLIENT_NAME: 'Marriott Media Network',
  URL: '/mi/mango/beacon',
  LOADED: 'page_loaded',
  key: 'type',
};
